export function compareMonthAndYear(d1: Date, d2: Date): number {
  const months1 = d1.getFullYear() * 12 + d1.getMonth();
  const months2 = d2.getFullYear() * 12 + d2.getMonth();

  if (months1 < months2) return -1; // d1 is earlier
  if (months1 > months2) return 1; // d1 is later
  return 0; // Months and years match
}

export function createUTCDate(dateString: string): Date {
  // Remove T
  if (dateString.includes("T")) {
    dateString = dateString.split("T")[0];
  }
  // Splits 'YYYY-MM-DD' into components
  const [year, month, day] = dateString.split("-").map(Number);

  // Note: JavaScript months are 0-indexed (0 = January, 1 = February)
  return new Date(Date.UTC(year, month - 1, day));
}
